export * from './mocks/mockOpportunities';
export * from './models/opportunity.interface';
export * from './opportunities.module';
export * from './services/opportunity.service';
